import { apiClient } from '@app/lib'
import { type SugarPaymentSetupResponse } from '@app/lib/server'
import { type ApiPaymentSetupInput } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const usePaymentSetup = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['paymentSetup'],
    mutationFn: async (paymentSetupInput: ApiPaymentSetupInput) => {
      const { data } = await apiClient.post<SugarPaymentSetupResponse>('/api/payment-setup', paymentSetupInput, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

      return data
    },
    // Prefix match clears both ['paymentSetup', 'ach'] and ['paymentSetup', 'w9'], which is why the
    // query key is nested: /payment-setup is a single combined form whose radio decides which resource
    // a submission touched, so we cannot know which one to invalidate.
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({
        queryKey: ['paymentSetup']
      })

      return data
    }
  })
}
